import {
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_LOADING,
} from '../actions/productAction';

const initialState = {
  productData: [],
  isLoading: true
};

const productReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PRODUCT_DETAILS_SUCCESS:
      return { ...state, productData: action.data, isLoading: false };
    case PRODUCT_DETAILS_LOADING:
      return { ...state, isLoading: action.isLoading };
    default:
      return state;
  }
};

export default productReducer;
